import { Component, Suspense } from 'react';
import { ConnectedRouter } from 'connected-react-router';

import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import AppAlerts from 'common/components/alerts/AppAlerts';

import ContentWrapper from 'components/layouts/ContentWrapper';
import RenderRoute from './components';

import NotFound from 'views/NotFound';

import accountRoutes from './routes/account';
import authRoutes from './routes/auth';
import indexesRoutes from './routes/indexes';
import dashboardRoutes from './routes/dashboard';
import enumsRoutes from './routes/enums';
import usersRoutes from './routes/users';
import companiesRoutes from './routes/companies';
import integrationsRoutes from './routes/integrations';
import routesAuthorization from './routes/authorization';
import routesRoutes from './routes/routes';
import reportsRoutes from './routes/reports';
import beaconRoutes from './routes/beacon';
import aiLogsRoutes from './routes/ai-logs';

import paths from 'routing/routes/_paths';
import PageLoader from '@/library/components/general/PageLoader';

const tempRoutes = [
  '/integrations',
  '/authorization',
  '/routes',
  '/enums/cargo',
  '/enums/ports',
  '/routes',
  '/enums/classification-societies',
  '/enums/vessels',
  '/enums/widget-types',
  'enums/cp-forms',
  'enums/routing-areas',
  'enums/fuel-grades',
  '/ml-reports',
  '/companies',
  '/users',
  '/indexes'
];

const mergedRoutes = [
  ...accountRoutes,
  ...authRoutes,
  ...indexesRoutes,
  ...dashboardRoutes,
  ...enumsRoutes,
  ...usersRoutes,
  ...companiesRoutes,
  ...integrationsRoutes,
  ...routesAuthorization,
  ...routesRoutes,
  ...reportsRoutes,
  ...beaconRoutes,
  ...aiLogsRoutes,
  ...tempRoutes.map(t => ({
    path: t,
    type: 'private',
    exact: true,
    app: true,
    component: () => <div>Nothing to see here yet</div>
  }))
];
class AppRouter extends Component {
  render() {
    return (
      <ConnectedRouter history={this.props.history}>
        <ContentWrapper routes={mergedRoutes}>
          <Suspense fallback={<PageLoader isLoading={true} />}>
            <Switch>
              {mergedRoutes.map((route, i) => (
                <RenderRoute authenticated={this.props.authenticated} key={i} strict {...route} />
              ))}
              <Route path={paths.not_found} exact component={NotFound} />
              <Redirect to={paths.not_found} />
            </Switch>
            <AppAlerts />
          </Suspense>
        </ContentWrapper>
      </ConnectedRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.isAuthenticated
  };
}

export default connect(mapStateToProps, {})(AppRouter);
